import { VCol, VContainer, VDialog, VLayout, VRow, VToolbar, VToolbarTitle } from 'vuetify/lib'
import './Contact.scss'
import Vue from 'vue'

export const Contact = Vue.component('Contact', {
	data: () => ({
		modalState: false
	}),

	methods: {
		openModal() {
			this.modalState = true
		}
	},

	render() {
		return (
			<VDialog tile width="450" v-model={this.modalState} overlay-color="#f3f3f3">
				<VToolbar flat dense color="primary">
					<VToolbarTitle style="color:#f2f2f7">Precisa de ajuda?</VToolbarTitle>
				</VToolbar>
				<VContainer style="background:#fff">
					<VLayout>
						<VRow>
							<VCol cols="12">
								<div class="ma-4 mb-3 mt-1 font-weight-regular text-subtitle-2">Mande um ticket para o nosso helpdesk.</div>
								<hr class="divisor" />

								<iframe
									src="https://atta-franchising.tomticket.com/formulario?id=EP33574&account=2148736P29072019122745"
									width="100%"
									height="480px"
									frameborder="0"
								></iframe>
							</VCol>
						</VRow>
					</VLayout>
				</VContainer>
			</VDialog>
		)
	}
})

export default Contact
